import NoDataIcon from "../../images/icons/table/noData.svg?react";
import { NoTableContentProps } from "./NoTableContentProps";

const NoTableContent = ({ title, columnCount }: NoTableContentProps) => {
    return (
        <tr>
            <td colSpan={columnCount} className="no-content">
                <h2>{title}</h2>
                <NoDataIcon />
            </td>
        </tr>
    );
};

export default NoTableContent;
